import {
  Box,
  Button,
  CircularProgress,
  styled,
  TextField,
  Typography,
} from "@mui/material"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const SearchInput = styled(TextField)({
  marginBottom: 5,
})

export const AlphabetTitle = styled(Typography)({
  margin: "30px 0 20px 0",
  display: "block",
})

export const ScrollingContainer = styled(Box)({
  height: "100%",
  overflow: "scroll",
})

export const StyledButton = styled(Button)({
  marginTop: "5px",
})

export const ClientContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 20,
  overflow: "scroll",
})

export const Loading = styled(CircularProgress)({
  margin: "auto",
})
